<template>
    <div>
        <OrderPanels
        :ordersApproval="ordersApproval"
        :ordersPending="ordersPending"/>
        <CartPanels
        :anonCarts="anonCarts"
        :userCarts="userCarts"/>
        <UserPanels
        :lastLogins="lastLogins"/>
        
    </div>
</template>

<script>
import CartPanels from "./components/CartPanels";
import OrderPanels from "./components/OrderPanels";
import UserPanels from "./components/UserPanels";

export default {
    components:{
        CartPanels,
        OrderPanels,
        UserPanels
    },
    props:{
        lastLogins:{
            type:String,
            default:""
        },
        anonCarts:{
            type:String,
            default:""
        },
        userCarts:{
            type:String,
            default:""
        },
        ordersApproval:{
            type:String,
            default:""
        },
        ordersPending:{
            type:String,
            default:""
        },
    }
}
</script>

<style lang="scss" scoped>

</style>